import { Route, Routes } from "react-router"

import AgentMissedCalls from "./agent-missed-calls"

const MissedInboundCallsRoot = () => {
  return (
    <Routes>
      <Route index element={<AgentMissedCalls />}></Route>
    </Routes>
  )
}

export default MissedInboundCallsRoot
